import { useDispatch, useSelector } from "react-redux";
import "./disconnected.scss";
import Modal from "parts/modal/modal";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { OAuth2Service } from "services/oauth2.service";
import { useEffect } from "react";
import { setTheme } from "store/theme.slice";
import { themes, type themesType } from "../../themes/themes";
import useDeviceDetection, { DEVICE_ORIENTATION, DEVICE_TYPE } from "hook/useDeviceDetection";
import { Link } from "react-router-dom";
import { logoMap } from "themes/themes";
import { useDeepLink } from "hook/useDeepLink";

const Disconnected = () => {
  const theme = useSelector((state: any) => state.theme);
  const { t } = useTranslation();
  const { device, orientation } = useDeviceDetection();
  const oauth2Service = new OAuth2Service();
  const dispatch = useDispatch();
  const LogoPath = logoMap[theme.id as keyof typeof logoMap];
  useDeepLink();

  useEffect(() => {
    dispatch(setTheme(
      {
        ...themes[process.env.REACT_APP_THEME as keyof themesType],
        isTabletPortraitOrMobile: (device === DEVICE_TYPE.TABLET && orientation === DEVICE_ORIENTATION.PORTRAIT) || device === DEVICE_TYPE.MOBILE
      }
    ));
  }, [device, orientation]);

  return (
    <div className={`disconnected ${theme.class} ${theme.isTabletPortraitOrMobile ? "isTabletPortraitOrMobile" : ""} ${orientation}`}>
      <LogoPath className="logo" />
      <h3>{t('app_text')}</h3>

      <Button key="connect" variant="light" className="connect btn_accent" onClick={() => oauth2Service.authorize(true)}>
        {t('connect')}
      </Button>

      <Modal />

      <footer>
        <p>
          <Link to="/legals">{t("legals")}</Link>
        </p>
      </footer>
    </div>
  );
};

export default Disconnected;